import gql from 'graphql-tag';

export const PROSPECTS_ADD_TO_COMMUNITY_MUTATION = gql`
  mutation ProspectsAddToCommunityMutation($prospects: [JSONObject!]!, $communityIds: [Int!]!, $userId: String, $source: String) {
    members: prospectsAddToCommunity(prospects: $prospects, communityIds: $communityIds, userId: $userId, source: $source) {
      id
    }
  }
`;
